module.exports = __webpack_public_path__ + "static/img/contact_bg.d3cbdad8.png";